var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 536,
    height: 395,
    viewBox: "0 0 536 395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 536,
    height: 395,
    transform: "translate(0 1080)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1080)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.98,0,549.532,423.9,151.2,822.227l-8.35-8.4.065-.059L3.669,672.387l-.059-.053,3.906-3.853,4.557-4.5L151.26,805.42,532.9,423.777,134.394,17.339,8.462,158.368,0,150.017Z",
    transform: "translate(0 653)",
    fill: "#040506"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoElement);
export default __webpack_public_path__ + "static/media/logo-element.03d66f70e9cffa2ed8d39d08467ef366.svg";
export { ForwardRef as ReactComponent };